import videojs from "video.js";
import { initQuality, quality } from "../../elements/player/qualityComponent";
import { initMenuFunctional } from "../../elements/player/videoMenu";

videojs.registerComponent('quality', quality);

const initVideo = () => {
	const sections = document.querySelectorAll( 'section.video' );

	sections.forEach( ( section ) => {

		if ( !section ) {
			return;
		}
		
		const videoId = section.getAttribute( 'id' );
		const player = videojs(`video-player-${videoId}`, {
			controls: true,
			inactivityTimeout: 1000,
			controlBar: {
				volumePanel: {
					inline: false
				},
			},
			menu: {
				children: [ 'PlaybackRateMenuButton' ],
			},
			responsive: true,
			playbackRates: [0.5, 1, 1.5, 2]
		});

		if ( window.innerWidth < 769 ) {
			player.options().inactivityTimeout = 7000;
		}
	
		player.getChild('menu').addChild('quality');
	
		player.on('play', () => {
			section.querySelector('h2').remove();
		})

		initMenuFunctional(player, section);
		initQuality(player, section);
	})
}

export {
	initVideo,
};
